import LoadingSpinner from "../../Components/LoadingSpinner";
import { ConvertPriceToString } from "../../../Helpers/CustomConverter";
import { TextBox } from "devextreme-react";
import { useParams } from "../../../Providers/ParamsProvider";


const Balance = ({ creditInfo, isLoading }) => {
    const { isMobile } = useParams()

    const handleCalculateTotal = (type) => {
        debugger
        if (!creditInfo) {
            return ConvertPriceToString(0)
        }
        else {
            if (type === 'unpaid') {
                return ConvertPriceToString(creditInfo.totalDocUnpaid - creditInfo.totalPurchUnpaid)

            } else if (type === 'overdue') {
                return ConvertPriceToString(creditInfo.totalDocOverdue - creditInfo.totalPurchOverdue)
            }
        }
    }

    return (
        <div className="row justify-content-center">
            <div className="justify-content-center">
                <div className="row">
                    <div className="col-12 col-md-6 col-xl">
                        <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Kredyt</label>
                        <TextBox
                            readOnly
                            value={ConvertPriceToString(creditInfo && creditInfo.grantCredit)}
                            placeholder="Kredyt"
                        />
                    </div>
                    <div className="col-12 col-md-6 col-xl">
                        <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Należności</label>
                        <TextBox
                            readOnly value={ConvertPriceToString(creditInfo && creditInfo.totalDocUnpaid)}
                            placeholder="Należności"
                        />
                    </div>
                    <div className="col-12 col-md-6 col-xl">
                        <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Zamówienia</label>
                        <TextBox
                            readOnly
                            value={ConvertPriceToString(creditInfo && creditInfo.totalOrderAmount)}
                            placeholder="Zamówienia"
                        />
                    </div>
                    <div className="col-12 col-md-6 col-xl">
                        <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">WZ</label>
                        <TextBox
                            readOnly
                            value={ConvertPriceToString(creditInfo && creditInfo.totalDispAmount)}
                            placeholder="WZ"
                        />
                    </div>
                    <div className="col-12 col-xl">
                        <label style={{ fontSize: '14px', fontWeight: 'bold' }} htmlFor="investment">Kredyt do wykorzystania</label>
                        <TextBox
                            readOnly
                            value={ConvertPriceToString(creditInfo && creditInfo.remainCredit)}
                            placeholder="Kredyt do wykorzystania"
                        />
                    </div>
                </div>
                <div className="table-responsive">
                    <div className="table-responsive mt-2">
                        <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                            <thead>
                                <tr>
                                    <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', width: '10%' }}></th>
                                    <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', width: '30%', textAlign: 'right' }}>NALEŻNOŚCI</th>
                                    <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', width: '30%', textAlign: 'right' }}>ZOBOWIĄZANIA</th>
                                    <th style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', width: '30%', textAlign: 'right' }}>SALDO</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!isLoading &&
                                    <>
                                        <tr className="hoverable-row">
                                            <td style={{ alignContent: "center", verticalAlign: 'middle' }}>WSZYSTKIE</td>
                                            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>{ConvertPriceToString(creditInfo && creditInfo.totalDocUnpaid)}</td>
                                            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>{ConvertPriceToString(creditInfo && creditInfo.totalPurchUnpaid)}</td>
                                            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>
                                                {handleCalculateTotal('unpaid')}
                                            </td>
                                        </tr>
                                        <tr className="hoverable-row">
                                            <td style={{ alignContent: "center", verticalAlign: 'middle' }}>ZALEGŁE</td>
                                            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>{ConvertPriceToString(creditInfo && creditInfo.totalDocOverdue)}</td>
                                            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>{ConvertPriceToString(creditInfo && creditInfo.totalPurchOverdue)}</td>
                                            <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right' }}>
                                                {handleCalculateTotal('overdue')}
                                            </td>
                                        </tr>
                                    </>
                                }
                            </tbody>
                        </table>
                        {isLoading && <LoadingSpinner width={2} height={2} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Balance;
